<script lang="ts" context="module">
    import {
        COLOR_RAPID,
        COLOR_STD,
        COLOR_HISTORIC_REPLACEMENT,
    } from "../js/dataLayer";

    import TileBlank from "./TileBlank.svelte";
</script>

<script lang="ts">
    export let hasMetro = false;
    export let hasRapid = false;
    export let hasHistoric = false;
    export let lineColor = hasMetro
        ? COLOR_RAPID
        : hasHistoric
        ? COLOR_HISTORIC_REPLACEMENT
        : hasRapid
        ? COLOR_RAPID
        : COLOR_STD;
</script>

<TileBlank {lineColor} />
<path
    transform="translate(12.5) scale(1.5)"
    fill="white"
    d="m 302.00656,186.63989 v -80.79093 c 0,0 0,-3.87078 -3.95418,-3.87078 -3.7514,0 -3.7514,3.87078 -3.7514,3.87078 V 217.15257 H 278.90129 V 90.407722 c 0,0 -0.36978,-19.228477 19.15109,-19.228477 19.22844,0 19.22844,19.228477 19.22844,19.228477 v 69.262118 c 0,0 0,26.97006 26.92839,26.97006 26.92828,0 26.92828,-26.97006 26.92828,-26.97006 V 32.471581 h 15.39953 V 186.63989 c 0,0 0,34.55053 -42.32781,34.55053 -42.20265,0 -42.20265,-34.55053 -42.20265,-34.55053 M 209.63918,159.84277 V 32.471581 h 15.4056 V 144.31204 c 0,0 -0.37573,3.8708 3.829,3.8708 4.24046,0 3.82901,-3.8708 3.82901,-3.8708 V 32.471581 h 15.39343 V 159.66984 c 0,0 1.58656,19.27026 -19.22244,19.27026 -20.77333,0 -19.2346,-19.09732 -19.2346,-19.09732 M 71.204583,178.94009 71.16325,105.84896 c 0,0 0,-3.87078 -3.835003,-3.87078 -3.864665,0 -3.864665,3.87078 -3.864665,3.87078 V 217.15257 H 48.105784 V 90.407722 c 0,0 0,-19.228477 19.222464,-19.228477 19.234602,0 19.234602,19.228477 19.234602,19.228477 v 69.262118 c 0,0 0,26.97006 26.88639,26.97006 26.97607,0 26.97607,-26.97006 26.97607,-26.97006 V 90.407722 c 0,0 -0.33988,-19.228477 19.1451,-19.228477 19.31204,0 19.31204,19.228477 19.31204,19.228477 V 217.15257 H 163.52464 V 105.84896 c 0,0 0,-3.87078 -3.95419,-3.87078 -3.74561,0 -3.74561,3.87078 -3.74561,3.87078 v 73.09113 c 0,0 -0.501,42.25033 -42.3756,42.25033 -41.874391,0 -42.244192,-42.25033 -42.244192,-42.25033 M 394.28439,32.471581 H 425 V 217.15257 h -30.71561 z m 0,0 M 186.58167,178.94001 V 90.407612 c 0,0 0,-26.844754 -27.01176,-26.844754 -26.84492,0 -26.84492,26.844754 -26.84492,26.844754 v 69.262098 c 0,0 0,19.2703 -19.27627,19.2703 -19.22844,0 -19.22844,-19.2703 -19.22844,-19.2703 V 90.407612 c 0,0 0,-26.844754 -26.892547,-26.844754 -26.928262,0 -26.928262,26.844754 -26.928262,26.844754 V 217.15249 H 25 V 71.179151 c 0,0 0,-42.369574 42.327733,-42.369574 42.333837,0 42.333837,42.369574 42.333837,42.369574 l 0.16703,73.669619 c 0,0 -0.16703,3.33398 3.62028,3.33398 4.03785,0 3.91248,-3.87082 3.91248,-3.87082 V 71.179151 c 0,0 0,-42.369574 42.20867,-42.369574 42.41126,0 42.33369,42.369574 42.33369,42.369574 l 0.078,88.490559 c 0,0 -1.24648,26.97009 26.89255,26.97009 28.17479,0 26.8866,-26.97009 26.8866,-26.97009 l 0.0351,-88.490559 c 0,0 0,-42.369574 42.25631,-42.369574 42.28604,0 42.28604,42.369574 42.28604,42.369574 l 0.12527,73.132779 c 0,0 -0.12527,3.87083 3.74564,3.87083 3.82897,0 3.82897,-3.87083 3.82897,-3.87083 V 32.471541 h 15.40545 V 159.66971 c 0,0 0,19.2703 -19.23442,19.2703 -19.27029,0 -19.27029,-19.2703 -19.27029,-19.2703 V 90.407612 c 0,0 0,-26.844754 -26.8866,-26.844754 -26.85074,0 -26.85074,26.844754 -26.85074,26.844754 v 88.532398 c 0,0 0,42.25032 -42.32786,42.25032 -42.29202,0 -42.29202,-42.25031 -42.29202,-42.25031"
/>
{#if hasMetro}
    <text
        class="w rapid"
        x="687.5"
        y="325"
        textLength="862.5"
        lengthAdjust="spacingAndGlyphs">METRO</text
    >
{:else if hasHistoric}
    <text
        class="w rapid"
        x="687.5"
        y="325"
        textLength="862.5"
        lengthAdjust="spacingAndGlyphs">HISTORIC</text
    >
{:else if hasRapid}
    <text
        class="w rapid"
        x="687.5"
        y="325"
        textLength="875"
        lengthAdjust="spacingAndGlyphs">RAPID</text
    >
{/if}
